<template lang='html'>
  <v-form ref="form">
    <div class='select-authentication-object'>
      <v-autocomplete
        :items='authenticationObjectsFormatted'
        v-model="internalValue.authenticationObject"
        append-icon="expand_more"
        dense
        outlined
        height="20"
        :placeholder="$t('select.authentication.object.placeholder')"
      />
    </div>
  </v-form>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'SelectAuthenticationObject',
  props: {
    value: Object,
    type: {
      required: true,
    },
    provider: {
      required: false,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  watch: {
    'internalValue.authenticationObject': {
      handler() {
        const currentAuthenticationObjectsKeys = Object.keys(this.internalValue.authenticationObject);
        if (currentAuthenticationObjectsKeys.length > 0 && currentAuthenticationObjectsKeys.includes('id')) {
          this.valid = true;
        }
      },
      deep: true,
    },
    valid() {
      this.$emit('updateValid', this.valid);
    },
  },
  computed: {
    ...mapGetters(['configurationAuthenticationObjects']),
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    authenticationObjectsFormatted() {
      return this.authenticationObjectFiltered.map(obj => ({
        text: obj.settingsMetaData.name,
        value: { ...obj },
      }));
    },
    authenticationObjectFiltered() {
      return this.configurationAuthenticationObjects.filter(obj => this.type.includes(obj.settingsMetaData.type) && (this.provider === obj.settingsMetaData.type || !this.provider));
    },
  },
};
</script>

<style lang='scss' scoped>
.select-authentication-object {
}
</style>
